import { useLazyQuery } from '@apollo/client/react';
import { useEffect } from 'react';

import { GetOutpatientQuestionnaireEntryOnQuestionnaireDocument } from '~/graphql/generated/graphql';
import { getNode } from '~/graphql/utility';

export const useFetchOutpatientQuestionnaireEntryQuestionnaires = (
  outpatientQuestionnaireEntryId: string | null,
) => {
  const [getOutpatientQuestionnaireEntry, { called, loading, data }] = useLazyQuery(
    GetOutpatientQuestionnaireEntryOnQuestionnaireDocument,
    {
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-first',
    },
  );

  const outpatientQuestionnaireEntry = getNode(data, 'OutpatientQuestionnaireEntry');

  useEffect(() => {
    if (outpatientQuestionnaireEntryId) {
      getOutpatientQuestionnaireEntry({ variables: { id: outpatientQuestionnaireEntryId } });
    }
  }, [outpatientQuestionnaireEntryId, getOutpatientQuestionnaireEntry]);

  return {
    loading: !called || loading,
    outpatientQuestionnaireEntry: outpatientQuestionnaireEntry,
  };
};
